export default "__VITE_ASSET__B2EdzP5u__";